import React from 'react'
import { Provider } from 'react-redux'
import { StyledEngineProvider, ThemeProvider } from '@mui/material'
import { ConfigProvider } from '../components/ConfigProvider'
import { ThemeConfig } from 'apex-ui-kit-pcn'
import BpImpersonation from '../components/BpImpersonation/BpImpersonation'
import { analyticsService } from '../services/analytics-service'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { configureStore } from '@reduxjs/toolkit'
import { rootReducer } from '../store/rootReducer'
import { OpenTelemetryManager } from '@measurement/opentelemetry-web'
import { getAppConfig } from 'config/appConfig'

export const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})

const PcnApp = props => {
  // Pageviews are tracked in the router, but only on changes
  // This tracks the first pageview or landing page
  analyticsService.pageView()

  return (
    <ConfigProvider>
      <AppWrapper>{props.children}</AppWrapper>
    </ConfigProvider>
  )
}

const AppWrapper = props => {
  // Causing stack trace issues in OpenTelemetry, so commenting out for now --- IGNORE ---
  OpenTelemetryManager.initialize(getAppConfig().otel)

  return (
    <Provider store={store}>
      <BpImpersonation>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <StyledEngineProvider injectFirst>
            <ThemeProvider theme={ThemeConfig}>{props.children}</ThemeProvider>
          </StyledEngineProvider>
        </LocalizationProvider>
      </BpImpersonation>
    </Provider>
  )
}

export default PcnApp
